//-----------------------------------------------------
// -- れてーな
//-----------------------------------------------------
export var retina = function() {
	var windowwidth = $(window).width();

	// Retinaディスプレイのときを分岐させている
	$('img.spimg').each(function() {
		if (windowwidth <= 736) {
			var retinaimg = $(this).attr('src').replace(/\.(?=(?:png|jpg|jpeg)$)/i, '_sp.');
			if (!$(this).attr('src').match('_sp')) {
				$(this).attr('src', retinaimg);
			}
		} else {
			var retinaimg = $(this).attr('src').replace('_sp', '');
			$(this).attr('src', retinaimg);
		}
	});

	var retinaCheck = window.devicePixelRatio;
	if (retinaCheck >= 2) {
		// Retinaディスプレイのときを分岐させている
		$('img.retina').each(function() {
			var retinaimg = $(this)
				.attr('src')
				.replace(/\.(?=(?:png|jpg|jpeg)$)/i, '@2x.');
			$(this).attr('srcset', retinaimg + ' 2x');
		});
	}
};